// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"Legacy_scroll-black__qecth","title":"Legacy_title__d9xwL","wrapper":"Legacy_wrapper__IsoJS","cards":"Legacy_cards__tm3_u","subtitle":"Legacy_subtitle__O5qVL"};